import { Capacitor } from '@capacitor/core';
import { Keyboard, KeyboardInfo } from '@capacitor/keyboard';
import { useEffect, useState } from 'react';

export type KeyboardState = {
  isVisible: boolean;
  keyboardHeight: number;
};

export interface KeyboardContextProps {
  keyboardState: KeyboardState;
  hideKeyboard: () => void;
  showKeyboard: () => void;
}

const isWeb = Capacitor.getPlatform() === 'web';

export const useKeyboard = () => {
  const [keyboardState, setKeyboardState] = useState<KeyboardState>({
    isVisible: false,
    keyboardHeight: 0,
  });

  const hideKeyboard = () => {
    if (isWeb) return;
    Keyboard.hide();
  };

  const showKeyboard = () => {
    if (isWeb) return;
    Keyboard.show();
  };

  useEffect(() => {
    if (isWeb) return;

    const onKeyboardWillShow = (info: KeyboardInfo) => {
      setKeyboardState({
        isVisible: true,
        keyboardHeight: info.keyboardHeight,
      });
    };

    const onKeyboardWillHide = () => {
      setKeyboardState({
        isVisible: false,
        keyboardHeight: 0,
      });
    };

    Keyboard.addListener('keyboardWillShow', onKeyboardWillShow);
    Keyboard.addListener('keyboardWillHide', onKeyboardWillHide);

    return () => {
      if (isWeb) return;

      Keyboard.removeAllListeners();
    };
  }, []);

  return {
    keyboardState,
    hideKeyboard,
    showKeyboard,
  };
};
